/**
 * Utility functions for price formatting
 */

export const formatPrice = (price) => parseFloat(price || 0).toFixed(2);

export const formatChange = (change) => parseFloat(change || 0).toFixed(2);

export const getChangeColorClass = (change) => {
  return change >= 0 ? "text-success" : "text-danger";
};

export const getChangePrefix = (change) => {
  return change >= 0 ? "+" : "";
};